<div class="container-fluid h-100">
  <div class="row mb-10px">
    <div class="col-12">
      <span class="title">{{ content.title }}</span>
      <span class="sub-title">({{completedCount}}/{{ finalCheckList.length }} Tasks)</span>
    </div>
  </div>
  <div class="container-fluid pb-3 container-content">
    <div class="row" *ngIf="finalCheckList.length > 0">
      <div class="col-12 p-0">
        <div class="flex-container" *ngFor="let item of finalCheckList">
          <div class="flex-item sl-no-width">
            <span class="sl-no">{{ item.slno }}</span>
          </div>
          <div class="flex-item content-width">
            <div>
              <span class="name" title="Personal Details">{{ item.sectionName }}</span>
            </div>
          </div>
          <div class="flex-item status-width">
            <a class="status" (click)="onRedirect(item)" *ngIf="!item.complete">Enter</a>
            <span class="pi pi-check" *ngIf="item.complete"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="!finalCheckList || finalCheckList.length === 0">
      <div class="col-12">
        <span class="no-data">No data available.</span>
      </div>
    </div>
  </div>
</div>
